import { DefaultContentFolderPreferencesPanel } from '@jarvis/platform-ui';

export function SettingsStoragePage() {
  return (
    <div className="user-settings-sections">
      <DefaultContentFolderPreferencesPanel />
    </div>
  );
}
